import { createEntityAdapter } from '@reduxjs/toolkit';

import { type IMediaItem } from 'api/media/types';

export const mediaItemsAdapter = createEntityAdapter<IMediaItem>({
  selectId: (item) => item.itemId,
});

export const selectors = mediaItemsAdapter.getSelectors();
